export default __webpack_public_path__ + "static/media/solomon.aea26ccd.jpg";